import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthGuard } from './guards/authentication-guard.service';
import { Router } from '@angular/router';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
constructor(
  private authService: AuthGuard,
  private router: Router,
) {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Check if a token is available in local storage.
    const token = localStorage.getItem('token');

    if (token) {
      // Clone the request to add the token to the headers.
      const clonedRequest = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });

      // Handle the request and response.
      return next.handle(clonedRequest).pipe(
        catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.authService.logoutAndRedirect();
        } else if (error.status === 403) {
          this.router.navigateByUrl('/unauthorized');
        }

        return throwError(() => error);
      })
      );
    } else {
      // No token found in local storage; proceed with the original request.
      return next.handle(request);
    }
  }
}
